'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _templateObject = _taggedTemplateLiteral(['\n  width: ', ';\n  & > path { fill: ', '; }\n'], ['\n  width: ', ';\n  & > path { fill: ', '; }\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Container = _styledComponents2.default.svg(_templateObject, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.color || props.theme['color_blue'];
});
var Person = function (_PureComponent) {
  _inherits(Person, _PureComponent);
  function Person() {
    _classCallCheck(this, Person);
    return _possibleConstructorReturn(this, (Person.__proto__ || Object.getPrototypeOf(Person)).apply(this, arguments));
  }
  _createClass(Person, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(Container, {
        viewBox: '0 0 49.25 47.4'
      }, _react2.default.createElement('path', {
        d: 'M26.4,49.81c-6.79,0-13.59-.13-20.38.06-3.36.09-4.15-1.29-3.74-4.33.95-7,8-13.21,15.74-13.42q8.79-.23,17.58,0c7.76.21,14.77,6.38,15.73,13.43.41,3.05-.4,4.41-3.75,4.32C40.52,49.68,33.46,49.81,26.4,49.81Zm22.07-2.75c.32-6.3-5.25-12.11-12.1-12.39-6.38-.26-12.79-.27-19.17,0-6.85.29-12.41,6.15-12,12.39Z',
        transform: 'translate(-2.17 -2.47)'
      }), _react2.default.createElement('path', {
        d: 'M26.56,28.26a12.93,12.93,0,0,1-13-12.88,13.11,13.11,0,0,1,26.21.28A12.78,12.78,0,0,1,26.56,28.26ZM26.57,5a10.55,10.55,0,0,0-10.5,10.71,11.1,11.1,0,0,0,10.61,10.4c5.5,0,10.8-5.23,10.78-10.73A10.77,10.77,0,0,0,26.57,5Z',
        transform: 'translate(-2.17 -2.47)'
      }));
    }
  }]);
  return Person;
}(_react.PureComponent);
exports.default = Person;
;